import { render } from "./CardMastercard.vue?vue&type=template&id=3c15db76"
const script = {}

import exportComponent from "../../../../Bocco/Rental/WebApp/Bocco/Rental/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__